class HealthJourney {
	constructor(sectionSelector = ".health-journey", sliderSelector = ".healthJourneySlider") {
		this.section = document.querySelector(sectionSelector)
		this.sliders = Array.from(document.querySelectorAll(sliderSelector))
		this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

		this.init()
	}

	init() {
		this.initSliders()
		this.initAnimation()
	}

	initSliders() {
		if (!this.sliders.length || typeof window.Swiper === "undefined") {
			return
		}

		this.sliders.forEach(slider => {
			this.createSlider(slider)
		})
	}

	createSlider(slider) {
		return new window.Swiper(slider, {
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true
			},
			centeredSlides: true,
			effect: "slide",
			grabCursor: true,
			keyboard: {
				enabled: true
			},
			loop: true,
			navigation: {
				nextEl: slider.querySelector(".swiper-button-next"),
				prevEl: slider.querySelector(".swiper-button-prev")
			},
			pagination: {
				clickable: true,
				el: slider.querySelector(".swiper-pagination")
			},
			spaceBetween: 0,
			speed: 800
		})
	}

	initAnimation() {
		if (!this.section) {
			return
		}

		if (this.prefersReducedMotion || typeof IntersectionObserver === "undefined") {
			this.section.classList.add("animate")
			return
		}

		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) {
						return
					}

					this.section.classList.add("animate")
					observer.unobserve(entry.target)
				})
			},
			{ threshold: 0.2 }
		)

		observer.observe(this.section)
	}
}

export default HealthJourney